<template>
  <div class="p-4">

    <div v-if="!loaded" class="text-center py-4 text-muted">
      <i class="ri-loader-4-line"></i> Cargando...
    </div>

    <div v-else>
      <!-- Resumen -->
      <div class="flex flex-wrap mb-4 -mx-2">
        <div class="w-full md:w-1/3 px-2">
          <div class="stat-card p-3 border rounded text-center">
            <div class="text-muted text-sm">Días de descanso (año actual)</div>
            <div class="font-bold h4 mb-0 text-primary">{{ summary.totalDaysThisYear }}</div>
          </div>
        </div>
        <div class="w-full md:w-1/3 px-2">
          <div class="stat-card p-3 border rounded text-center">
            <div class="text-muted text-sm">Descansos activos</div>
            <div class="font-bold h4 mb-0">{{ summary.activeCount }}</div>
          </div>
        </div>
        <div class="w-full md:w-1/3 flex items-center justify-center px-2">
          <wz-button
            variant="primary"
            size="sm"
            @click="goToCreate()"
          >
            <i class="ri-heart-pulse-line mr-1"></i> Registrar descanso
          </wz-button>
        </div>
      </div>

      <!-- Tabla de descansos -->
      <h5 class="mb-3">Historial de descansos médicos</h5>
      <div class="overflow-x-auto">
        <table class="wz-table">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Días</th>
              <th>Estado</th>
              <th class="text-center">Detalle</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="leaves.length === 0">
              <td colspan="6" class="text-center text-muted py-3">No hay descansos médicos registrados</td>
            </tr>
            <tr v-for="leave in leaves" :key="leave.id">
              <td>
                <wz-badge :variant="getTypeColor(leave.leaveType)">{{ getTypeLabel(leave.leaveType) }}</wz-badge>
              </td>
              <td v-local-date="leave.startDate"></td>
              <td v-local-date="leave.endDate"></td>
              <td>{{ leave.calendarDays }}</td>
              <td>
                <wz-badge :variant="getStatusColor(leave.status)">{{ leave.status }}</wz-badge>
              </td>
              <td class="text-center">
                <router-link :to="{ name: 'medical-leave-detail', params: { id: leave.id } }" class="text-primary">
                  <i class="ri-eye-line"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { MedicalLeaveService } from '@/core/services'
import { Constants } from '@/core/utils'

export default {
  name: 'MedicalLeavesTab',
  props: {
    employeeId: {
      type: Number,
      default: null,
    },
    contracts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loaded: false,
      summary: { totalDaysThisYear: 0, activeCount: 0 },
      leaves:  [],
    }
  },
  methods: {
    // Nuevo DM desde la ficha: companyId es obligatorio en el alta. Si el colaborador tiene contrato
    // vigente en una sola empresa, se autoselecciona; si tiene varias, el usuario la elige en el form.
    goToCreate() {
      const companyIds = [...new Set(
        (this.contracts || [])
          .map(c => (c.company && c.company.id) || c.companyId)
          .filter(id => id != null),
      )]
      const query = { employeeId: this.employeeId }
      if (companyIds.length === 1) query.companyId = companyIds[0]
      this.$router.push({ name: 'medical-leave-create', query })
    },
    getTypeColor(leaveType) {
      const found = Object.values(Constants.MedicalLeaveType).find(t => t.key === leaveType)
      return found ? found.color : 'dark'
    },
    getTypeLabel(leaveType) {
      const found = Object.values(Constants.MedicalLeaveType).find(t => t.key === leaveType)
      return found ? found.label : leaveType
    },
    getStatusColor(status) {
      const found = Object.values(Constants.MedicalLeaveStatus).find(s => s.key === status)
      return found ? found.color : 'dark'
    },
  },
  async mounted() {
    if (!this.employeeId) { this.loaded = true; return }
    try {
      const [summaryResp, leavesResp] = await Promise.all([
        MedicalLeaveService.getSummary(this.employeeId),
        MedicalLeaveService.getByEmployee(this.employeeId),
      ])
      this.summary = summaryResp.payload  || { totalDaysThisYear: 0, activeCount: 0 }
      this.leaves  = leavesResp.payload   || []
    } catch (e) {
      Alert.error('Error al cargar descansos médicos')
    } finally {
      this.loaded = true
    }
  },
}
</script>
